const tw = require('../../../../tailwind.config');

// the default color for popular link
export const PRIMARY = tw.theme.colors.primary.DEFAULT;
export const SECONDARY = tw.theme.colors.secondary.DEFAULT;
export const ACCENT = tw.theme.colors.accent.DEFAULT;
